/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Delete_TitleInputs */

const en_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Preset`)
};

const fr_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le prereglage`)
};

const de_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung löschen`)
};

const it_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina preimpostazione`)
};

const ru_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить предустановку`)
};

const es_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar ajuste preestablecido`)
};

const zh_cn2_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除预设`)
};

const ja_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを削除`)
};

const hi_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट हटाएं`)
};

const pt_pt2_image_export_style_preset_delete_title = /** @type {(inputs: Image_Export_Style_Preset_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir predefinição`)
};

/**
* | output |
* | --- |
* | "Delete Preset" |
*
* @param {Image_Export_Style_Preset_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_delete_title = /** @type {((inputs?: Image_Export_Style_Preset_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_delete_title(inputs)
	if (locale === "de") return de_image_export_style_preset_delete_title(inputs)
	if (locale === "it") return it_image_export_style_preset_delete_title(inputs)
	if (locale === "ru") return ru_image_export_style_preset_delete_title(inputs)
	if (locale === "es") return es_image_export_style_preset_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_delete_title(inputs)
	if (locale === "ja") return ja_image_export_style_preset_delete_title(inputs)
	if (locale === "hi") return hi_image_export_style_preset_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_delete_title(inputs)
	return en_image_export_style_preset_delete_title(inputs)
});